export const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';
export const CHECK_USER_PROFILE = 'CHECK_USER_PROFILE';
export const SET_USER_COMPANY_UID = 'SET_USER_COMPANY_UID';
export const FETCH_PROXY_REQUEST = 'FETCH_PROXY_REQUEST';
export const FETCH_PROXY_SUCCESS = 'FETCH_PROXY_SUCCESS';
export const FETCH_PROXY_FAILURE = 'FETCH_PROXY_FAILURE';
export const CHECK_PROXY = 'CHECK_PROXY';
